import { render, staticRenderFns } from "./CompanyGenerate.vue?vue&type=template&id=dc5235f0&"
import script from "./CompanyGenerate.vue?vue&type=script&lang=js&"
export * from "./CompanyGenerate.vue?vue&type=script&lang=js&"
import style0 from "./CompanyGenerate.vue?vue&type=style&index=0&id=dc5235f0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports